export const LOADING_STATUS = 'loading';
export const READY_STATUS = 'ready';

export const MODULE_NAME = 'requestStatus';
